/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateProductListMutationVariables = Types.Exact<{
  input: Types.CreateProductListInput;
}>;


export type CreateProductListMutation = { createProductList: { __typename: 'CreateProductListResult', productList: { __typename: 'ProductList', id: string } } };


export const CreateProductListDocument = gql`
    mutation CreateProductList($input: CreateProductListInput!) {
  createProductList(input: $input) {
    productList {
      id
    }
  }
}
    `;
export type CreateProductListMutationFn = Apollo.MutationFunction<CreateProductListMutation, CreateProductListMutationVariables>;

/**
 * __useCreateProductListMutation__
 *
 * To run a mutation, you first call `useCreateProductListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductListMutation, { data, loading, error }] = useCreateProductListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductListMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductListMutation, CreateProductListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductListMutation, CreateProductListMutationVariables>(CreateProductListDocument, options);
      }
export type CreateProductListMutationHookResult = ReturnType<typeof useCreateProductListMutation>;
export type CreateProductListMutationResult = Apollo.MutationResult<CreateProductListMutation>;
export type CreateProductListMutationOptions = Apollo.BaseMutationOptions<CreateProductListMutation, CreateProductListMutationVariables>;